import {
  LIBRARY_CATEGORIES_PAGE_REQUEST,
  LIBRARY_CATEGORIES_LIST_REQUEST,
  LIBRARY_CATEGORIES_SET_LIST_CATEGORIES,
  LIBRARY_CATEGORIES_ON_CHANGE_OUTLET_IDS,
  LIBRARY_CATEGORIES_SET_OUTLETS,
  LIBRARY_CATEGORIES_SET_CURRENT_PAGE,
  LIBRARY_CATEGORIES_SET_TOTAL_PAGE,
  LIBRARY_CATEGORIES_SET_KEYWORD,
  LIBRARY_CATEGORIES_ON_CLICK_ROW,
  LIBRARY_CATEGORIES_SET_CATEGORY_DETAIL,
  LIBRARY_CATEGORIES_ON_CLICK_CANCEL,
  LIBRARY_CATEGORIES_ON_CLICK_CREATE_CATEGORY,
  LIBRARY_CATEGORIES_SUBMIT_FORM_UPDATE,
  LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE,
  LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE_ALL_OUTLETS,
  LIBRARY_CATEGORIES_DELETE_CATEGORY_REQUEST,
  LIBRARY_CATEGORIES_SHOW_DELETE_MODAL,
  LIBRARY_CATEGORIES_HIDE_DELETE_MODAL,
  LIBRARY_CATEGORIES_SHOW_UPDATE_MODAL,
  LIBRARY_CATEGORIES_HIDE_UPDATE_MODAL,
  LIBRARY_CATEGORIES_CANCEL_DELETE,
  LIBRARY_CATEGORIES_DELETE_CATEGORY,
  LIBRARY_CATEGORIES_SET_DELETED_CATEGORY,
  LIBRARY_CATEGORIES_ON_CLICK_ASSIGN_TO_ITEM,
  LIBRARY_CATEGORIES_SHOW_ASSIGN_TO_ITEM_MODAL,
  LIBRARY_CATEGORIES_HIDE_ASSIGN_TO_ITEM_MODAL,
  LIBRARY_CATEGORIES_CANCEL_ASSIGN_TO_ITEM,
  LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_ITEMS,
  LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_CURRENT_PAGE,
  LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_TOTAL_PAGE,
  LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_GET_ITEMS_REQUEST,
  LIBRARY_CATEGORIES_SUBMIT_ASSIGN_TO_ITEM,
  LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_FILL_FORM,
  LIBRARY_CATEGORIES_OPEN_RIGHT_COLUMN,
  LIBRARY_CATEGORIES_CLOSE_RIGHT_COLUMN,
  LIBRARY_CATEGORIES_IS_SUBMITTING_FORM,
} from './constants';

export function categoriesPageRequest() {
  return { type: LIBRARY_CATEGORIES_PAGE_REQUEST, payload: {} };
}

export function categoriesRequest(params, previousCategories) {
  return {
    type: LIBRARY_CATEGORIES_LIST_REQUEST,
    payload: { params, previousCategories },
  };
}

export function setListCategories(categories) {
  return {
    type: LIBRARY_CATEGORIES_SET_LIST_CATEGORIES,
    payload: { categories },
  };
}

export function onChangeOutletIds(outletIds) {
  return {
    type: LIBRARY_CATEGORIES_ON_CHANGE_OUTLET_IDS,
    payload: { outletIds },
  };
}

export function setOutlets(outlets) {
  return { type: LIBRARY_CATEGORIES_SET_OUTLETS, payload: { outlets } };
}

export function setCurrentPage(currentPage) {
  return {
    type: LIBRARY_CATEGORIES_SET_CURRENT_PAGE,
    payload: { currentPage },
  };
}

export function setTotalPage(totalPage) {
  return { type: LIBRARY_CATEGORIES_SET_TOTAL_PAGE, payload: { totalPage } };
}

export function setKeyword(keyword) {
  return { type: LIBRARY_CATEGORIES_SET_KEYWORD, payload: { keyword } };
}

export function onClickRow(category) {
  return { type: LIBRARY_CATEGORIES_ON_CLICK_ROW, payload: { category } };
}

export function setCategoryDetail(category) {
  return {
    type: LIBRARY_CATEGORIES_SET_CATEGORY_DETAIL,
    payload: { category },
  };
}

export function onClickCancel() {
  return { type: LIBRARY_CATEGORIES_ON_CLICK_CANCEL, payload: {} };
}

export function onClickCreateCategory() {
  return { type: LIBRARY_CATEGORIES_ON_CLICK_CREATE_CATEGORY, payload: {} };
}

export function submitFormUpdate(id, data, previousCategories) {
  return {
    type: LIBRARY_CATEGORIES_SUBMIT_FORM_UPDATE,
    payload: { id, data, previousCategories },
  };
}

export function submitFormCreate(data, previousCategories) {
  return {
    type: LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE,
    payload: { data, previousCategories },
  };
}

export function submitFormCreateAllOutlets(data, previousCategories) {
  return {
    type: LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE_ALL_OUTLETS,
    payload: { data, previousCategories },
  };
}

export function setDeletedCategory(deletedCategory) {
  return {
    type: LIBRARY_CATEGORIES_SET_DELETED_CATEGORY,
    payload: { deletedCategory },
  };
}

export function deleteCategoryRequest(deletedCategory) {
  return {
    type: LIBRARY_CATEGORIES_DELETE_CATEGORY_REQUEST,
    payload: { deletedCategory },
  };
}

export function showDeleteModal() {
  return { type: LIBRARY_CATEGORIES_SHOW_DELETE_MODAL, payload: {} };
}

export function hideDeleteModal() {
  return { type: LIBRARY_CATEGORIES_HIDE_DELETE_MODAL, payload: {} };
}

export function showUpdateModal() {
  return { type: LIBRARY_CATEGORIES_SHOW_UPDATE_MODAL, payload: {} };
}

export function hideUpdateModal() {
  return { type: LIBRARY_CATEGORIES_HIDE_UPDATE_MODAL, payload: {} };
}

export function cancelDelete() {
  return { type: LIBRARY_CATEGORIES_CANCEL_DELETE, payload: {} };
}

export function deleteCategory(id, previousCategories) {
  return {
    type: LIBRARY_CATEGORIES_DELETE_CATEGORY,
    payload: { id, previousCategories },
  };
}

export function onClickAssignToItem(category) {
  return {
    type: LIBRARY_CATEGORIES_ON_CLICK_ASSIGN_TO_ITEM,
    payload: { category },
  };
}

export function showAssignToItemModal() {
  return { type: LIBRARY_CATEGORIES_SHOW_ASSIGN_TO_ITEM_MODAL, payload: {} };
}

export function hideAssignToItemModal() {
  return { type: LIBRARY_CATEGORIES_HIDE_ASSIGN_TO_ITEM_MODAL, payload: {} };
}

export function cancelAssignToItem() {
  return { type: LIBRARY_CATEGORIES_CANCEL_ASSIGN_TO_ITEM, payload: {} };
}

export function assignToItemSetItems(items) {
  return {
    type: LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_ITEMS,
    payload: { items },
  };
}

export function assignToItemSetCurrentPage(currentPage) {
  return {
    type: LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_CURRENT_PAGE,
    payload: { currentPage },
  };
}

export function assignToItemSetTotalPage(totalPage) {
  return {
    type: LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_TOTAL_PAGE,
    payload: { totalPage },
  };
}

export function assignToItemGetItemsRequest(params, previousItems) {
  return {
    type: LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_GET_ITEMS_REQUEST,
    payload: { params, previousItems },
  };
}

export function submitAssignToItem(data, categoryId) {
  return {
    type: LIBRARY_CATEGORIES_SUBMIT_ASSIGN_TO_ITEM,
    payload: { data, categoryId },
  };
}

export function assignToItemFillForm(category) {
  return {
    type: LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_FILL_FORM,
    payload: { category },
  };
}

export function openRightColumn() {
  return { type: LIBRARY_CATEGORIES_OPEN_RIGHT_COLUMN, payload: {} };
}

export function closeRightColumn() {
  return { type: LIBRARY_CATEGORIES_CLOSE_RIGHT_COLUMN, payload: {} };
}

export function isSubmittingForm(isSubmittingForm) {
  return {
    type: LIBRARY_CATEGORIES_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm },
  };
}
